export const routes = [
  {
      path: '/site',
      name: 'site',
      component: () => import('./../layout/blank/Blank.vue'),
      children: [{
          path: 'login',
          name: 'login',
          component: () => import('./../views/authentication/Login.vue'),
          meta: { title: `Login` }
      }, {
          path: 'error404',
          name: 'error 404',
          component: () => import('./../views/authentication/Error404.vue'),
          meta: { title: `Error found` }
      }, {
          path: 'register',
          name: 'register',
          component: () => import('./../views/authentication/Register.vue'),
          meta: { title: `Registration` }
      }, {
          path: 'forgotpassword',
          name: 'forgotpassword',
          component: () => import('./../views/authentication/ResetPassword.vue'),
          meta: { title: `Reset Password` }
      },
      {
          path: 'confirm/:token',
          name: 'confirm',
          component: () => import('./../views/authentication/Confirm.vue'),
          meta: { title: `Activate account` }
      },
      {
          path: 'change-password/:token',
          name: 'changepassword',
          component: () => import('./../views/authentication/ChangePassword.vue'),
          meta: { title: `Change Password` }
      }]
  },
  {
      // Full Layout
      path: '',
      meta: {isAuth: true},
      component: () => import('./../layout/full/MainContainer.vue'),
      children: [{
          path: '/',
          name: 'StarterPage',
          component: () => import('./../views/StarterPage.vue'),
          meta: { title: 'Dashboard' }
      },{
          path: '/users',
          component: () => import('./../layout/blank/Blank.vue'),
          children: [{
              path: '',
              meta: { title: `Users`},
              component: () => import('./../views/users/List.vue'),
              name: 'Users List',
          },{
              path: 'profile',
              name: 'profile',
              component: () => import('./../views/users/Profile.vue')
          },{
              path: ':id',
              name: 'user',
              props: true,
              component: () => import('./../views/users/User.vue')
          }]
      }]
  },
  // Redirect to 404 page, if no match found
  {
      path: '*',
      redirect: '/site/error404'
  }
];
